import { Observable } from '@reactivex/rxjs';
import { pathValue as $value, ref as $ref, atom as $atom } from '@graphistry/falcor-json-graph';

import {
    SEARCH
} from '@graphistry/viz/src/actions/search';

export function search(action$, store) {
    var actions = action$.ofType(SEARCH);
    return Observable
        .merge(
            actions
                .switchMap(({ falcor, term }) =>
                    falcor.set($value('searchTerm', term))
                ),
            actions
                .debounceTime(300)
                .switchMap(({ falcor, term }) =>
                    falcor.call('search', [term])
                )
        )
        .ignoreElements();
}
